'use client';

import { useState, useEffect } from 'react';
import { IconTooltip } from '@sympla/sympla-components/InfoIcons';
import * as styles from './UserDataCompletionBanner.css';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { getJwtFromBiletoUserCookie, shouldShowProfileCompletionBanner } from 'utils/decodeJwt';
import { buildCompletionRedirectUrl } from 'utils/buildCompletionRedirectUrl';

function UserDataCompletionBanner() {
  const [shouldShowBanner, setShouldShowBanner] = useState(false);

  useEffect(() => {
    const token = getJwtFromBiletoUserCookie();
    const shouldShow = shouldShowProfileCompletionBanner(token);
    setShouldShowBanner(shouldShow);
  }, []);

  const completionBannerParams = useFeatureValue('discovery-next-completion-banner-params', {
    active: false,
    deadline: '',
    completionPercentage: 0,
    redirectUrl: ''
  });

  if (!completionBannerParams?.active || !shouldShowBanner) return null;

  const { deadline, completionPercentage, redirectUrl } =
    completionBannerParams;

  return (
    <div className={styles.bannerContainer}>
      <div className={styles.contentWrapper}>
        <IconTooltip className={styles.infoIcon} />
        <p className={styles.bannerText}>
          Complete seus dados{' '}
          <span className={styles.boldText}>até dia {deadline}</span> para{' '}
          <span className={styles.boldText}>
            garantir mais segurança no acesso à sua conta!
          </span>
        </p>
      </div>

      <div className={styles.progressBarContainer}>
        <div className={styles.progressBarBackground}>
          <div
            className={styles.progressBarFill}
            style={{ width: `${completionPercentage}%` }}
          />
        </div>
        <span className={styles.progressPercentage}>
          {completionPercentage}%
        </span>
      </div>

      <button
        className={styles.completeButton}
        onClick={() => {
          window.location.href = buildCompletionRedirectUrl({
            redirectUrl,
            currentUrl: window.location.href
          });
        }}
      >
        Completar dados
      </button>
    </div>
  );
}

export default UserDataCompletionBanner;
